import { useSelector } from 'react-redux'
import { Link } from '../misc/Link'
import styles from './styles/LinkResolverLink.css'
import * as analytics from 'lib/analytics'

const LinkResolverLink = ({
  doi,
  issns,
  memberId,
  referenceStyle,
  handleFulltextClick = () => { }
}) => {
  const linkResolver = useSelector(({ ui }) => ui.linkResolver)
  if (!linkResolver) {
    return ''
  }

  let resolverURL = ''
  if (!linkResolver?.baseURL) {
    try {
      resolverURL = 'https://' + (new URL(linkResolver?.referrerLocation)).hostname + linkResolver?.resolverPrefix
    } catch (e) {
      return ''
    }
  } else if (linkResolver?.baseURL) {
    resolverURL = linkResolver?.baseURL
  }
  let resolverHref = linkResolver && `${resolverURL}?&rft_id=info:doi/${doi}`
  if (linkResolver?.additionalParams) {
    resolverHref += `&${linkResolver.additionalParams}`
  }
  if (linkResolver.imageURL) {
    return (
      <Link
        className={styles.link}
        onClick={() => handleFulltextClick({ doi, issns, memberId, partnerName: linkResolver.partnerName })}
        href={resolverHref} target='_blank' rel='noopener noreferrer nofollow'
      >
        {linkResolver.imageURL && <img src={linkResolver.imageURL} alt='link resolver' />}
      </Link>
    )
  }

  if (linkResolver.text) {
    return (
      <>{referenceStyle && '|'}
        <Link
          className={referenceStyle && styles.referenceStyle}
          blue
          onClick={() => {
            analytics.event({
              category: 'Report',
              action: 'Clicked buy/rent full text link',
              label: linkResolver.partnerName
            })
            handleFulltextClick({ doi, issns, memberId, partnerName: linkResolver.partnerName })
          }}
          href={resolverHref} target='_blank' rel='noopener noreferrer nofollow'
        >

          {linkResolver.text}
        </Link>
      </>
    )
  }

  return null
}
export default LinkResolverLink
